import { defineStore } from "pinia";

export const useUiStore = defineStore("UiStore", {
  state: () => {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
  },

  getters: {
    isSm: ({ windowWidth }) => {
      return windowWidth >= 640 && windowWidth < 768;
    },
    isSmPlus: ({ windowWidth }) => {
      return windowWidth >= 640;
    },
    isMd: ({ windowWidth }) => {
      return windowWidth >= 768 && windowWidth < 1024;
    },
    isMdPlus: ({ windowWidth }) => {
      return windowWidth >= 768;
    },
    isLg: ({ windowWidth }) => {
      return windowWidth >= 1024 && windowWidth < 1280;
    },
    isLgPlus: ({ windowWidth }) => {
      return windowWidth >= 1024;
    },
    isXL: ({ windowWidth }) => {
      return windowWidth >= 1280 && windowWidth < 1536;
    },
    isXlPlus: ({ windowWidth }) => {
      return windowWidth >= 1280;
    },
    is2XL: ({ windowWidth }) => {
      return windowWidth >= 1536;
    },
  },

  actions: {
    syncWindow() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },
  },
});
